import React, { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import createCtx from '~utils/createCtx';

export type ContextValue = {
  isXs: boolean;
  isMd: boolean;
  isLg: boolean;
  isXl: boolean;
  width: number;
};

export type Props = {
  breakpoints: {
    md: number;
    lg: number;
    xl: number;
  };
  children: React.ReactNode;
};

const CustomWidow = {
  innerWidth: 1024,
  addEventListener() {},
  removeEventListener() {}
}

export const widthContextData = createCtx<ContextValue>();

export const WidthContextProvider = ({ breakpoints, children }: Props) => {
  const { Context } = widthContextData;
  const _window = typeof window !=='undefined' ? window : CustomWidow;
  const [width, setWidth] = useState<number>(_window.innerWidth);

  const onResize = () => {
    setWidth(_window.innerWidth);
  };

  const debouncedOnResize = debounce(onResize, 400);

  useEffect(() => {
    _window.addEventListener('resize', debouncedOnResize);

    return () => {
      _window.removeEventListener('resize', debouncedOnResize);
    };
  }, []);

  const contextValue = {
    isXs: width < breakpoints.md,
    isMd: width >= breakpoints.md && width < breakpoints.lg,
    isLg: width >= breakpoints.lg && width < breakpoints.xl,
    isXl: width >= breakpoints.xl,
    width,
  };

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};
